import { createSvgIcon } from "@mui/material/utils";

// The stacked-cylinder database glyph from the Data Hub design. MUI has no cylinder equivalent — its closest icon,
// Storage, is three rectangular bars and is already used for Data Sources. Strokes are set per shape because SvgIcon
// fills with currentColor by default.
const DatabaseIcon = createSvgIcon(
  <>
    <ellipse
      cx="12"
      cy="5.5"
      rx="7.5"
      ry="3"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
    />
    <path
      d="M4.5 5.5v6c0 1.66 3.36 3 7.5 3s7.5-1.34 7.5-3v-6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M4.5 11.5v6c0 1.66 3.36 3 7.5 3s7.5-1.34 7.5-3v-6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </>,
  "Database"
);

export default DatabaseIcon;
